<template>
  <div class="applyforhelp">
    <header-view :tabsign="2"></header-view>
    <div class="pic">申请帮扶</div>
    <div class="body w12 min-h">
      <div class="toptitle">
        <div class="left_c">
          <div class="redcon"></div>
          <span>申请帮扶</span>
        </div>
      </div>
      <div class="content" v-if="isType == 0">
        <div class="title">申请帮扶须知</div>
        <div class="box">
          <div>1. 申请者须同意以下条款，方可进行申请。</div>
          <div>
            2. 请如实填报您个人或单位的真实信息，并按要求提供相应的完整资料。
          </div>
          <div>3. 信息审核通过后，我们将会有工作人员联系您。</div>
          <div>4. 我们会对您提交的信息进行隐私保护。</div>
        </div>
        <div class="selectbtn" @click="changeSelect">
          <div :class="isSelect ? 'selected' : 'select'"></div>
          <div class="instruction">本人已阅读、接受并同意申请须知。</div>
        </div>
        <div class="btn">
          <div class="confirm" @click="confirm">确认</div>
          <div class="cancel" @click="toIndexHome">返回首页</div>
        </div>
      </div>
      <div class="formlist" v-if="isType == 1">
        <el-form
          :model="ruleForm"
          label-position="left"
          ref="ruleForm"
          label-width="1.8rem"
        >
          <el-form-item label="帮扶类型:">
            <div class="helpType">
              <div class="help_item" @click="changeHelpType">
                <div :class="isPerson ? 'selected' : 'select'"></div>
                <div class="text">个人</div>
              </div>
              <div class="help_item" @click="changeHelpType">
                <div :class="!isPerson ? 'selected' : 'select'"></div>
                <div class="text">集体</div>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <el-form :model="ruleForm" label-position="left" ref="ruleForm" label-width="1.8rem" :rules="rules">

          <el-form-item v-if='isPerson' label="个人姓名:" prop="name" >
            <el-input
              v-model="ruleForm.name"
              class="ipt"
              placeholder="请输入个人姓名"
            ></el-input>
          </el-form-item>

          <el-form-item v-else label="公司名称:" prop="cname" >
            <el-input
              v-model="ruleForm.cname"
              class="ipt"
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>

          <el-form-item label="联系方式:" prop="phone">
            <el-input
              v-model="ruleForm.phone"
              class="ipt"
              placeholder="请输入联系方式"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证正反面:" prop="cid" v-if="isPerson">
            <upFile :fileList='cid' :len="2" @success='pimgSuccess' type='cid'></upFile>
          </el-form-item>
          <el-form-item label="证件执照:" prop="license" v-if="!isPerson" class="mtb">
            <upFile :fileList='license' :len="1" @success='uimgSuccess' type='license'></upFile>
          </el-form-item>
          <el-form-item label="身份证号码:" prop="cardNo" v-if="isPerson" class="mtb">
            <el-input v-model="ruleForm.cardNo" class="ipt" placeholder="请输入身份证号码" ></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码:" prop="cCardNo" v-if="!isPerson">
            <el-input v-model="ruleForm.cCardNo" class="ipt" placeholder="请输入统一社会信用代码" ></el-input>
          </el-form-item>
          <el-form-item label="上传附件:">
            <upFile :fileList='fileId' :len="3" @success='pfileSuccess' type='file'></upFile>
          </el-form-item>
          <el-form-item label="申请事项:" prop="matters">
            <el-input
              type="textarea"
              size="medium"
              maxlength="500"
              :autosize="{ minRows: 5 }"
              v-model="ruleForm.matters"
              placeholder="请输入申请事项"
              show-word-limit
              class="iptarea"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="submit" @click="submit">提交</div>
      </div>
      <div class="audit" v-if="isType == 2">
        <img class="audit_img" src="../../assets/newimg/aAudit.png" alt="" />
        <div class="instruction">
          提交成功！信息审核通过后，我们将会有工作人员联系您。
        </div>
        <div class="cancel" @click="toIndex">返回到申请帮扶页</div>
      </div>
    </div>
  </div>
</template>

<script>
import upFile from './../../com/upFile.vue'
export default {
  components:{ 
    upFile
  },
  data: function () {
    return {
      isSelect: false,
      isPerson: true,
      cid:"",
      license:'',
      fileId:'',
      ruleForm: {
        name: "",
        cname: "",
        phone: "",
        cid: "",
        license: "",
        matters: "",
        cCardNo:'',
        cardNo:'',
      },
      isType: 0,
      rules: {
        name: [
          {
            required: true,
            message: "请输入个人姓名",
            trigger: ["blur", "change"],
          }, // 'blur'是鼠标失去焦点的时候会触发验证
        ],
        cname: [
          {
            required: true,
            message: "请输入公司名称",
            trigger: ["blur", "change"],
          }, // 'blur'是鼠标失去焦点的时候会触发验证
        ],
        phone: [
          {
            required: true,
            message: "请输入联系方式",
            trigger: ["blur", "change"],
          },
          {
            pattern: /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/,
            message: "手机号码不对",
            trigger: ["blur", "change"],
          },
        ],
        cid: [
          {
            required: true,
            message: "请上传身份证正反面",
            trigger: ["blur", "change"],
          },
          {
            // validate: true,
            // message: "请上传身份证正反面,共两张",
             validator(_, value, callback){
                // rule：采用的规则
                // value: 被校验的值
                // callback是回调函数， 
                //      如果通过了规则检验，就直接调用callback()
                //      如果没有通过规则检验，就调用callback(错误对象，在错误对象中说明原因)
                //         例如：callback(new Error('错误说明'))
                if(value.indexOf(',')==-1){
                  callback(new Error('请上传身份证正反面,共两张'))
                } else{
                  callback()
                }
              },
              trigger: ["blur", "change"],
          },
        ],
        license: [
          {
            required: true,
            message: "请上传证件执照",
            trigger: ["blur", "change"],
          },
        ],
        matters: [
          {
            required: true,
            message: "请输入申请事项",
            trigger: ["blur", "change"],
          },
        ],
        cCardNo:[
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: ["blur", "change"],
          },
          {
            pattern: /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/,
            message: "统一社会信用代码格式不对",
            trigger: ["blur", "change"],
          },
        ],
        cardNo:[
          {
            required: true,
            message: "请输入身份证号码",
            trigger: ["blur", "change"],
          },
          {
            pattern: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
            message: "身份证号码格式不对",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  created() {},
  mounted() {
    window.pageYOffset = 0;
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
  methods: {
    changeHelpType() {
      this.isPerson = !this.isPerson;
      this.$nextTick(()=>{ 
        this.$refs.ruleForm.validate()
      });
    },
    changeSelect() {
      this.isSelect = !this.isSelect;
    },
    confirm() {
      if (!this.isSelect) {
        // alert("请勾选本人已阅读、接受并同意申请须知。");
        this.$message.warning("请勾选本人已阅读、接受并同意申请须知。")
        return;
      }
      this.isType = 1;
      window.pageYOffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    },
    submit(ruleForm) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          var param = {
            helpType: this.isPerson?1:2,//帮扶类型
            companyName: this.isPerson?this.ruleForm.name:this.ruleForm.cname,//姓名/公司名称
            companyPhone: this.ruleForm.phone,//联系方式
            companyImg:this.isPerson?this.ruleForm.cid:this.ruleForm.license,//证件照片
            helpContent: this.ruleForm.matters,//帮扶内容
            fileId:this.fileId,//附件
            cardNo:this.isPerson?this.ruleForm.cardNo:this.ruleForm.cCardNo,
          }
          console.log(111,param)
          
          this.httpPost("web/thpCompanyHelp/addCompanyHelp", param).then(res => {
            if(res.success){
              this.isType = 2;
              window.pageYOffset = 0;
              document.documentElement.scrollTop = 0;
              document.body.scrollTop = 0;
              this.$message.success("提交成功！");
            }	    
          });	
        } else {
          // alert("请填写数据！");
          return false;
        }
      });
    },
    toIndexHome(){
      this.$router.push({ path: "/" });
    },
    toIndex() {
      // this.$router.push({ path: "/" });
      this.isSelect=false;
      this.cid="";
      this.license=''
      this.fileId=''
      this.ruleForm={
        name: "",
        cname: "",
        phone: "",
        cid: "",
        license: "",
        matters: "",
        cCardNo:'',
        cardNo:'',
      }
      this.isType=0
    },
    // 图片上传成功
    pimgSuccess(e) {
      this.cid=e
      this.$set(this.ruleForm,'cid',e)
      this.$forceUpdate();
      this.$refs.ruleForm.validate()
    },
    // 执照上传成功
    uimgSuccess(e) {
      this.license=e;
      this.$set(this.ruleForm,'license',e)
      this.$forceUpdate();
      this.$refs.ruleForm.validate()
    },
    // 附件上传成功
    pfileSuccess(e) {
      this.fileId=e
      this.$set(this.ruleForm,'fileId',e)
      this.$forceUpdate();
      this.$refs.ruleForm.validate()
    },
  },
  
};
</script>
<style scoped="scoped" lang="scss">
.mtb{
  // margin: 30px 0px!important;
}
.applyforhelp {
  width: 100%;
  position: relative;
  .pic {
    width: 100%;
    height: 400px;
    font-size: 75px;
    font-weight: 500;
    color: #e61f26;
    text-align: center;
    line-height: 400px;
    margin-top: 100px;
    background: url(../../assets/newimg/publicannounce_img.png) no-repeat top
      center/ 100% 100%;
  }
  .body {
    background: #ffffff;
    margin: 20px auto 100px;
    .formlist {
      width: 900px;
      margin:60px auto 0;
      .submit {
        width: 168px;
        height:36px;
        text-align: center;
        line-height:36px;
        background-color: #ff0000;
        color: #ffffff;
        font-size: 16px;
        font-weight: 400;
        margin: 30px auto;
        cursor: pointer;
      }
      .ipt {
        width: 274px;
      }
      .upload_img {
        width: 137px;
        height: 136px;
      }
      .upload_btn {
        width: 110px;
        height: 27px;
        background: #ff0000;
        border-radius: 3px;
        color: #ffffff;
        font-size: 15px;
        font-weight: 400;
        line-height:27px;
      }
      .iptarea {
        width: 732px;
        background: #ffffff;
      }
      .helpType {
        display: flex;
        .help_item {
          cursor: pointer;
          display: flex;
          align-items: center;
          .select,.selected{
            width:16px;
            height:16px;
            border-radius: 50%;
            margin-right: 5px;
          }
          .select {
            background: #e5e5e5;
          }
          .selected {
            background: #e61f26;
          }
          .text {
            font-size: 16px;
            font-weight: 400;
            color: #333333;
            margin-right: 30px;
          }
        }
      }
    }
    .content {
      widows: 100%;
      .title {
        width: 100%;
        text-align: center;
        font-size: 26px;
        font-weight: 400;
        color: #333333;
        line-height: 50px;
      }
      .box {
        width: 540px;
        font-size: 16px;
        font-weight: 400;
        color: #666666;
        line-height: 50px;
        margin: 30px auto 0;
      }
      .selectbtn {
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 40px;
        .select,.selected{
          width:16px;
          height:16px;
          border-radius: 50%;
          margin-right: 15px;
        }
        .select {
          background: #e5e5e5;
        }
        .selected {
          background: #e61f26;
        }
        .instruction {
          font-size: 16px;
          font-weight: 400;
          color: #666666;
        }
      }
      .btn {
        width: 363px;
        margin: 40px auto;
        display: flex;
        justify-content: space-between;
        .confirm,.cancel{
          cursor: pointer;
          width: 168px;
          height: 36px;
          text-align: center;
          line-height:36px;
          font-size: 16px;
          font-weight: 400;
        }
        .confirm {
          color: #ffffff;
          background-color: #e61f26;
        }
        .cancel {
          color: #000000;
          background-color: #e6e6e6;
        }
      }
    }
    .audit {
      width: 100%;
      margin-top: 50px;
      text-align: center;
      .audit_img {
        width: 294px;
        height: 294px;
      }
      .instruction {
        font-size: 16px;
        font-weight: 400;
        color: #e61f26;
        margin-top: 20px;
      }
      .cancel {
        cursor: pointer;
        width: 168px;
        height: 36px;
        text-align: center;
        line-height: 36px;
        background-color: #e6e6e6;
        font-size: 16px;
        font-weight: 400;
        color: #000000;
        margin: 30px auto;
      }
    }
    .toptitle {
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left_c {
        display: flex;
        align-items: center;
        font-size: 25px;
        font-weight: 400;
        color: #e61f26;
        .redcon {
          width:5px;
          height: 20px;
          background: #e70012;
          margin-right: 20px;
        }
      }
    }
  }
}
</style>